
export const presentConstruction = (submissionVM) => {
    return (submissionVM.lobData.homeowners.coverables.dwellings.value.every((dwelling) => (dwelling.construction?.heaters.length > 0))) 
}